import { IHeaderParams } from "@ag-grid-community/core";
import { Box } from "@chakra-ui/layout";
import React, { useCallback, useEffect, useState } from "react";
import { FilterIcon } from "shared/icons/FilterIcon";

export const MaybernTableColumnFilterIndicator: React.FC<{
  onClick?: () => void;
}> = ({ onClick }) => (
  <Box
    cursor="pointer"
    onClickCapture={(e) => {
      e.stopPropagation();
      onClick?.();
    }}
  >
    <FilterIcon color="primary.600" />
  </Box>
);

export const useMaybernTableColumnFilterState = (props: IHeaderParams) => {
  const [isFilterActive, setFilterActive] = useState(
    props.column.isFilterActive(),
  );

  useEffect(() => {
    const listener = () => {
      setFilterActive(props.column.isFilterActive());
    };
    props.column.addEventListener("filterChanged", listener);
    return () => {
      props.column.removeEventListener("filterChanged", listener);
    };
  }, [props.column]);

  const showColumnFilter = useCallback(() => {
    props.api.showColumnFilter(props.column.getColId());
  }, [props]);

  return { isFilterActive, showColumnFilter };
};
